import * as Yup from "yup";

/**
 * Obrazac pregazivanja u čarobnjaku.
 *
 * Ovdje su samo pravila oblika. Je li popust prevelik i traži li odobrenje odlučuje backend —
 * prag se ne računa u pregledniku.
 */
export const SUBSCRIPTION_OVERRIDE_FORM_SCHEMA = Yup.object().shape({
  keyCode: Yup.string().nullable().required("Ključ je obavezan"),
  value: Yup.number()
    .nullable()
    .required("Vrijednost je obavezna")
    .when("adjustmentType", {
      is: "Percent",
      then: (schema) =>
        schema.min(-100, "Postotak ne može biti manji od −100 %"),
      otherwise: (schema) => schema.min(0, "Iznos ne može biti negativan"),
    }),
  reason: Yup.string().nullable().required("Razlog je obavezan"),
  validFrom: Yup.string().nullable().required("Datum početka je obavezan"),
  validTo: Yup.string()
    .nullable()
    .required("Rok je obavezan")
    .test(
      "after-valid-from",
      "Rok mora biti nakon početka",
      (value, context) => !value || !context.parent.validFrom || value > context.parent.validFrom
    ),
});
